/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import cn from 'clsx';
import { Form } from 'antd';
import { AModal, AButton, ASelectCreate, ACheckbox, ACheckboxGroup } from 'components/Antd';
import { useCreate } from 'context/ResourceProvider/hooks/useCreate';
import FormItem from 'views/DesktopReview/components/FormItem';
import classes from './AddModal.module.scss';

const AddModal = ({
  open,
  onClose,
  onSubmit,
  typeOptions,
  nameOptions,
  reloadTypeOptions,
  reloadNameOptions,
  editObj,
}) => {
  const isEdit = !!editObj;
  const [loading, setLoading] = useState(false);
  const { mutate: createCustomOptions } = useCreate({
    resource: 'compliance-custom-options',
  });
  const [form] = Form.useForm();
  const handleCreateType = async (newOption) => {
    form.setFieldValue(`type`, newOption.value);
    const res = await createCustomOptions({
      name: newOption.value,
      type: 'productRequirementType',
    });
    reloadTypeOptions(() => {
      if (res?.data?.data?.id) {
        form.setFieldValue('type', res.data.data.id);
      }
    });
  };
  const handleCreateName = async (newOption) => {
    form.setFieldValue(`name`, newOption.value);
    const res = await createCustomOptions({
      name: newOption.value,
      type: 'productRequirementName',
    });
    reloadNameOptions(() => {
      if (res?.data?.data?.id) {
        form.setFieldValue('name', res.data.data.id);
      }
    });
  };

  useEffect(() => {}, []);

  return (
    <>
      <AModal
        title={`${isEdit ? 'Edit' : 'Add'} Requirement`}
        open={open}
        onCancel={onClose}
        closable
        width={700}
        className={cn(classes.modalWrapper)}>
        <Form
          name="addForm"
          initialValues={{
            type: isEdit ? editObj?.typeObj?.customTypeId || null : null,
            name: isEdit ? editObj?.requirementObj?.customNameId || null : null,
            required: isEdit ? (editObj?.requirementObj?.isMandatory ? ['required'] : []) : [],
          }}
          onFinish={(values) => {
            if (onSubmit) {
              setLoading(true);
              onSubmit(values, () => {
                setLoading(false);
              });
            }
            // TODO: handle submit with values
          }}
          form={form}
          autoComplete="off"
          layout="vertical"
          className={classes.formWrapper}>
          <div className={classes.formInner}>
            <FormItem
              label="Type"
              name="type"
              required
              rules={[{ required: true, message: 'This field is required!' }]}>
              <ASelectCreate
                placeholder="Fill or select"
                options={typeOptions}
                showSearch
                size="large"
                radius="md"
                name="type"
                allowClear
                onCreate={handleCreateType}
              />
            </FormItem>
            <FormItem
              label="Name"
              name="name"
              required
              rules={[{ required: true, message: 'This field is required!' }]}>
              <ASelectCreate
                placeholder="Fill or select"
                options={nameOptions}
                showSearch
                size="large"
                radius="md"
                name="name"
                allowClear
                onCreate={handleCreateName}
              />
            </FormItem>
            <FormItem name="required">
              <ACheckboxGroup>
                <ACheckbox value="required">Mandatory</ACheckbox>
              </ACheckboxGroup>
            </FormItem>
          </div>
          <div className={classes.footer}>
            <AButton
              htmlType="submit"
              type="primary"
              size="large"
              className={classes.confirmBtn}
              loading={loading}>
              Confirm
            </AButton>
          </div>
        </Form>
      </AModal>
    </>
  );
};

export default AddModal;
